<template>
  <!-- 发布投稿弹窗 -->
  <n-modal
    transform-origin="center"
    v-model:show="showModal"
    display-directive="if"
    :mask-closable="false"
    :close-on-esc="false"
    @after-leave="afterLeave"
  >
    <div class="modal_content">
      <div class="div_modal_header flex_between">
        <h3>投稿到社区</h3>
        <i class="key_icon cp_us" @click="showModal = false">&#xe75c;</i>
      </div>
      <div class="div_modal_content">
        <n-input
          ref="refinput"
          type="text"
          v-model:value="inputValue"
          :placeholder="nowSelect.title == '' ? '请选择卡盒' : nowSelect.title"
          :maxlength="28"
          size="large"
          autofocus
          @focus="focusInput"
          @blur="blurInput"
          @input="inputSearch"
        >
          <template #suffix>
            <i
              class="key_icon i_input admin_easing"
              :class="showFileList ? '' : 'icon_down'"
              >&#xe75d;</i
            >
          </template>
        </n-input>
        <n-collapse-transition :show="showFileList">
          <div class="div_file_list" @mousedown.prevent.stop="">
            <!-- <n-scrollbar v-if="!isFirst"> -->
            <FilesTreeSelect
              :nowSelect="nowSelect"
              :list="fileList"
              @change="changeSelect"
            ></FilesTreeSelect>
            <!-- </n-scrollbar> -->
          </div>
        </n-collapse-transition>
      </div>
      <div class="div_modal_bottom flex_center">
        <n-button
          size="large"
          text-color="#333333"
          strong
          secondary
          type="tertiary"
          @click="showModal = false"
        >
          取消
        </n-button>
        <n-button
          size="large"
          type="primary"
          color="#000000"
          :loading="nextLoading"
          :disabled="nowSelect.id == -1 ? true : false"
          @click="clickNext()"
        >
          下一步
        </n-button>
      </div>
    </div>
  </n-modal>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useMessage } from "naive-ui";

import { chooseFile } from "@/api/user.js";
import { checkUserFile } from "@/api/file.js";

import FilesTreeSelect from "../other/filesTreeSelect.vue";

const message = useMessage();
const router = useRouter();

let showModal = ref(false);
// 是否显示选择文件弹窗
let showFileList = ref(false);
// 选中的文件
let fileList = ref([]);
let nowSelect = ref({ id: -1, type: 0, title: "" });
//输入框
let inputValue = ref("");
let isFirst = ref(true);
// 下一步
let nextLoading = ref(false);
//---ref---
let refinput = ref(null);

function afterLeave() {
  nowSelect.value = { id: -1, type: 0, title: "" };
  inputValue.value = "";
  showFileList.value = false;
  isFirst.value = true;
  nextLoading.value = false;
}
// 点击输入框
function focusInput() {
  if (isFirst.value) {
    findOneFiles(() => {
      showFileList.value = true;
      isFirst.value = false;
    });
  } else {
    showFileList.value = true;
  }
}
function blurInput() {
  showFileList.value = false;
}
// 选择文件
function changeSelect(val) {
  inputValue.value = "";
  nowSelect.value = val;
  refinput.value.blur();
}
// 搜索文件
function inputSearch() {
  isFirst.value = true;
  chooseFile({ title: inputValue.value }).then((res) => {
    fileList.value = setList(res.data);
    isFirst.value = false;
  });
}
// 查找首层文件夹
function findOneFiles(callback) {
  chooseFile({ title: "" }).then((res) => {
    fileList.value = setList(res.data);
    callback();
  });
}
// 处理数据,"c5","c7", "c8","c9",
let needType = ["f0", "c0", "c2", "c6", "c12", "c5", "c7", "c8", "c9"];
function setList(list) {
  let newList = [];
  list.forEach((val) => {
    let obj = {
      id: val.id,
      title: val.title,
      type: val.fileType,
      number: val.cardNum || null,
    };
    if (obj.type == "f0") {
      obj.children = [];
      obj.isOpened = false; //是否展开
      obj.isFirstLoad = true; //是否第一次加载
    }
    // 暂时仅仅保留卡盒与文件夹
    if (needType.includes(obj.type)) {
      newList.push(obj);
    }
  });
  return newList;
}
// 关闭选择文件弹窗
function closeSelect() {
  showFileList.value = false;
}
// 点击下一步
function clickNext() {
  verification(() => {
    showModal.value = false;
    let routeUrl = router.resolve({
      name: "creativeSubmission",
      query: {
        fileId: nowSelect.value.id,
        fileType: nowSelect.value.type,
        title: nowSelect.value.title,
      },
    }).href;
    setTimeout(() => {
      window.open(routeUrl, "_blank");
    }, 300);
  });
}
function verification(callback) {
  nextLoading.value = true;
  checkUserFile({
    id: nowSelect.value.id,
    type: nowSelect.value.type[0] == "c" ? 0 : 1,
  }).then((res) => {
    nextLoading.value = false;
    callback();
    return;
    if (res.code == 200) {
      callback();
    } else {
      message.error("卡片数量不足30张，无法投稿～");
      nowSelect.value = { id: -1, type: 0, title: "" };
      inputValue.value = "";
      refinput.value.focus();
    }
  });
}
defineExpose({
  showModal,
});
</script>

<style lang='scss' scoped>
.modal_content {
  width: 654px;
  padding: 30px;
  border-radius: 15px;
  background-color: white;
  .div_modal_header {
    > h3 {
      font-weight: 500;
      font-size: 19px;
      color: #000000;
    }
    i {
      color: #9d9d9d;
    }
  }
  .div_modal_content {
    height: 500px;
    padding-top: 24px;
    box-sizing: border-box;
    .i_input {
      color: #b9bbbe;
    }

    .icon_down {
      transform: rotate(180deg);
    }
    .div_file_list {
      width: 100%;
      height: 430px;
      margin-top: 4px;
      border-radius: 5px;
      border: 1px solid #dcddde;
      overflow-y: auto;
      box-sizing: border-box;
      .file_list {
        height: 600px;
      }
    }
  }
  .div_modal_bottom {
    padding-top: 10px;
    > button {
      width: 180px;
      height: 50px;
      margin: 0px 10px;
      border-radius: 12px;
    }
  }
}
:deep(.n-input__placeholder) {
  color: #333333;
}
</style>